export default __webpack_public_path__ + "static/media/CreateIPAdmission.90643b9f.svg";